import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Order, Size } from '../../../order.model';
import { User } from '../../../../auth/user.model';
import { AuthService } from '../../../../auth/auth.service';
import { OrderService } from '../../../order.service';

export interface DialogData {
  address: string;
  size_wanted: Size;
  id: number;
}

@Component({
  selector: 'app-set-for-pickup',
  templateUrl: './set-for-pickup.component.html',
  styleUrls: ['./set-for-pickup.component.css']
})
export class SetForPickupComponent implements OnInit {

  user: User;

  constructor(
    public dialogRef: MatDialogRef<SetForPickupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private orderService: OrderService,
    private authentication: AuthService,
  ) { }

  ngOnInit() {
    this.user = this.authentication.getUser();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  authorizePickup($event, order) {
    this.orderService.setOrderReadyForPickup(this.user.token, order).subscribe((result: Order) => {
        this.dialogRef.close();
    });
  }
}
